import React, { useContext } from 'react'
import { Icon } from '@conekta/frontino-ui/Icon'
import { OnboardingAsideContext } from 'apps/Onboarding/views/BlueBook/context/OnboardingAsideContext'
import { OnboardingAsideInner } from '../OnboardingAsideInner/OnboardingAsideInner'
import { useOpen } from 'hooks/useOpen'
import { useTranslation } from 'react-i18next'
import './OnboardingAsideMobile.scss'

export const OnboardingAsideMobile = (): React.ReactElement => {
  const { t } = useTranslation()
  const { handleClose, handleOpen, open } = useOpen()
  const { asideInfo } = useContext(OnboardingAsideContext)
  const { title } = asideInfo

  const handleClick = (): void => {
    handleOpen()
  }

  return (
    <div className='onboarding-aside-mobile'>
      <a className='onboarding-aside-mobile__btn' onClick={handleClick}>
        <Icon className='onboarding-aside-mobile__btn-icon'>help_outlined</Icon>
        {title}
      </a>
      {open && (
        <div className='onboarding-aside-mobile__card-wrapper' onClick={handleClose}>
          <div className='onboarding-aside-mobile__card-content'>
            <OnboardingAsideInner />
            <div className='onboarding-aside-mobile__card-close'>
              <a onClick={handleClose}>{`${t('command.close')}`}</a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
